
import React, { Component } from 'react';

export function FilterIcon() {
    return (
        <span className="lnr lnr-funnel action-icon"></span>
    )
}

export function NewIcon() {
    return (
        <span className="lnr lnr-file-add action-icon"></span>
    )
}

export function SettingIcon() {
    return (
        <span className="lnr lnr-cog action-icon"></span>
    )
}

export function ClearIcon() {
    return (
        <span className="lnr lnr-cross-circle action-icon"></span>
    )
}

class CharIcon extends Component {
    render() {
        return (
            <span className="char-icon">{this.props.char}</span>
        )
    }
}
export { CharIcon };
